









































































































































































































































































import { Component, Vue, Ref, Prop } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import { onlyNumber, timeout, maskMoney } from '@/utils/common'
import EventBus from '@/plugins/EventBus'

@Component

export default class ComponenteBackofficeSuprimentos extends Vue {
  @Prop({ required: false, default: false }) necessitaDeProfissionalAdicional: boolean
  @Prop({ required: true, default: false }) readOnly: boolean
  @Prop({ required: false, default: false }) tipoMaterial: boolean
  @Prop({ required: false, default: false }) tipoMaterialDisabled: boolean
  @Prop({ required: true, default: true }) quantidadeAutorizada: boolean
  @Prop({ required: true, default: true }) boasPraticas: boolean
  @Prop({ required: true, default: true }) equipamento: boolean
  @Prop({ required: true, default: true }) precificacao: boolean
  @Prop({ required: true, default: true }) profissional: boolean
  @Prop({ required: true, default: true }) grade: boolean
  @Prop({ required: true, default: true }) observacao: boolean
  @Prop({ required: true, default: true }) cotacao: boolean
  @Prop({ required: true, default: true }) valorUnitario: boolean
  @Prop({ required: true, default: true }) valorNegociado: boolean
  @Prop({ required: true, default: true }) valorTotal: boolean
  @Prop({ required: true, default: false }) codigoHospitalDisabled: boolean
  @Prop({ required: true, default: false }) cotacaoDisabled: boolean
  @Prop({ required: true, default: false }) valorUnitarioDisabled: boolean
  @Prop({ required: true, default: true }) valorNegociadoDisabled: boolean
  @Prop({ required: false, default: false }) precificacaoDisabled: boolean
  @Prop({ required: false, default: false }) necessitaDeProfissionalAdicionalDisabled: boolean

  $refs!: {
    codigoHospital: any,
    valorUnitario: any,
    valorNegociado: any,
    quantidadeAutorizada: any,
    formSuprimentos: any[],
  }

  tiposDeMaterial: any[] = [
    { value: 'Opme', text: 'OPME' },
    { value: 'Cme', text: 'CME' },
    { value: 'Medicamento', text: 'Medicamento' },
    { value: 'Equipamento', text: 'Equipamento' },
  ]

  hospitalValorNegociado: boolean = false

  get getTemplate() {
    return this.getBackofficeGlobalStore.template.formulario
  }

  get fornecedorLabel() {
    return this.getTemplate && this.getTemplate.opmes && this.getTemplate.opmes.fornecedorLabel
      ? this.getTemplate.opmes.fornecedorLabel
      : 'fornecedor / marca'
  }

  get hospitalTemValorNegociado() {
    return this.getBackofficeGlobalStore.solicitacao.hospitalInformaCotacaoDeOpmeNaAreaDeSuprimentos
  }

  codigoRules: any = {
    valid: true,
    codigo: [v => this.validarCodigo(v) || 'Campo obrigatório'],
  }

  valorUnitarioRules: any = {
    valid: true,
    valorUnitario: [v => this.validarValorUnitario(v) || 'Campo obrigatório'],
  }

  valorNegociadoRules: any = {
    valid: true,
    valorNegociado: [v => this.validarValorNegociado(v) || 'Campo obrigatório'],
  }

  validarCodigo(value) {
    if (this.getBackofficeGlobalStore.solicitacao.situacao.key === 'EmAutorizacao') return true
    return !!value
  }

  validarValorUnitario(value) {
    if (['EmAutorizacao', 'AguardandoSuprimentos'].includes(this.getBackofficeGlobalStore.solicitacao.situacao.key)) return true
    return parseFloat(value) > 0
  }

  validarValorNegociado(value) {
    if (['EmAutorizacao', 'AguardandoSuprimentos'].includes(this.getBackofficeGlobalStore.solicitacao.situacao.key)) return true
    return parseFloat(value) > 0
  }

  quantidadeAutorizadaRules: any = {
    valid: true,
    quantidadeAutorizada: [v => (v !== null && v !== '') || 'Campo obrigatório'],
  }

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get habilitarGrade() {
    return this.getTemplate && this.getTemplate.opmes && this.getTemplate.opmes.habilitarGrade
  }

  get colspan() {
    return [
      this.tipoMaterial,
      this.quantidadeAutorizada,
      this.equipamento,
      this.precificacao,
      this.profissional,
      this.cotacao,
      this.valorUnitario,
      this.valorNegociado,
      this.valorTotal,
      this.necessitaDeProfissionalAdicional,
      (this.grade && this.habilitarGrade),
      (this.observacao && this.habilitarGrade),
    ].filter((e: boolean) => e === true).length
  }

  get getOpmesFornecedor() {
    return this.getBackofficeGlobalStore.solicitacao.opmeFornecedores
  }

  get getOpmes() {
    return this.getBackofficeGlobalStore.solicitacao.grupoOpmeDaSolicitacao
  }

  get grupoOpmeApi() {
    return this.getBackofficeGlobalStore.grupoOpmeApi
  }

  mesmaDescricao(firstString: string, secondString: string) {
    return (!!firstString && !!secondString) && String(firstString).trim().toUpperCase() !== String(secondString).trim().toUpperCase()
  }

  hasCodigoHospital(suprimentoId: string, opmeId: string) {
    const grupoOPMEApi = this.grupoOpmeApi.find((e: any) => e.id === suprimentoId)
    const grupoOPME = this.getBackofficeGlobalStore.solicitacao.grupoOpmeDaSolicitacao.find((e: any) => e.id === suprimentoId)
    // @ts-ignore
    if (grupoOPME !== undefined && grupoOPMEApi !== undefined) {
      // @ts-ignore
      const opmeApi = grupoOPMEApi.opmes.find((e: any) => e.opmeId === opmeId)
      // @ts-ignore
      const opme = grupoOPME.opmes.find((e: any) => e.opmeId === opmeId)
      // @ts-ignore
      return !['', undefined, null].includes(opme.codigoHospital) && !['', undefined, null].includes(opmeApi.codigoHospital)
    }
    return false
  }

  isQuantidadeAutorizadaValid() {
    const isValid = !this.$refs.quantidadeAutorizada.some(c => c.validate() === false)
    return isValid
  }

  isCodigoHospitalValid() {
    const isValid = !this.$refs.codigoHospital.some(c => c.validate() === false)
    return isValid
  }

  isValorUnitarioValid() {
    const isValid = !this.$refs.valorUnitario.some(c => c.validate() === false)
    return isValid
  }

  isValorNegociadoValid() {
    const isValid = !this.$refs.valorNegociado.some(c => c.validate() === false)
    return isValid
  }

  onlyNumberUtil(value) {
    return onlyNumber(value)
  }

  maskMoneyUtil(value) {
    return maskMoney(value)
  }

  total(id: string) {
    const grupo = this.getBackofficeGlobalStore.solicitacao.grupoOpmeDaSolicitacao.find((e: any) => e.id === id)
    const sum = !grupo
      ? 0
      : grupo.opmes.reduce((acc, curr) => {
        const valorUnitario = !['', 0, null, undefined, NaN].includes(curr.valorUnitario) ? curr.valorUnitario : 0
        const quantidade = !['', 0, null, undefined, NaN].includes(curr.quantidade) ? curr.quantidade : 1
        const soma = acc + (valorUnitario * quantidade)
        return soma
      }, 0)
    return sum
  }

  get getConfiguracaoOpme() {
    return this.getBackofficeGlobalStore.solicitacao.configuracaoOpme
  }

  get temNaoInformadoOuNaoHomologadoComoFornecedor() {
    const { grupoOpmeDaSolicitacao } = this.getBackofficeGlobalStore.solicitacao
    if (grupoOpmeDaSolicitacao.length === 0) return false
    const algumNaoInformadoOuNaoHomologado: boolean[] = []
    grupoOpmeDaSolicitacao.forEach((grupo: any) => {
      grupo.opmes.forEach((opme: any) => {
        if (!opme.fornecedor1) algumNaoInformadoOuNaoHomologado.push(false)
        if (!opme.fornecedor2) algumNaoInformadoOuNaoHomologado.push(false)
        if (!opme.fornecedor3) algumNaoInformadoOuNaoHomologado.push(false)

        // Caso não exista a flag de alertaFornecedorNaoInformado, utilizar o método antigo
        const invalido = (f: string) => {
          const e = f
          return opme[e] === undefined
            ? false
            : opme[e].nome.toUpperCase() === 'NÃO INFORMADO' || !!opme[e].alertaFornecedorNaoInformado
        }

        algumNaoInformadoOuNaoHomologado.push((!!opme.fornecedor1 && !!opme.fornecedor1.alertaFornecedorNaoHomologado) || invalido('fornecedor1'))
        algumNaoInformadoOuNaoHomologado.push((!!opme.fornecedor2 && !!opme.fornecedor2.alertaFornecedorNaoHomologado) || invalido('fornecedor2'))
        algumNaoInformadoOuNaoHomologado.push((!!opme.fornecedor3 && !!opme.fornecedor3.alertaFornecedorNaoHomologado) || invalido('fornecedor3'))
      })
    })
    return algumNaoInformadoOuNaoHomologado.some((e: boolean) => e)
  }
}
